import { Injectable } from '@angular/core';

@Injectable()
export class DataModel {
    public constructor(
        public id: string,
        public title: string,
        public input: {},
        public dataType: string
        ) {
    }

}
